var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mmp-legend-card scroll-Container" }, [
    _c(
      "div",
      {
        staticClass: "mmp-legend-header",
        class: { "mmp-legend-header--no-border": _vm.legendMinimized },
      },
      [
        _c(
          "span",
          {
            staticClass: "capitalize mmp-legend-title",
            attrs: { id: "modifiedLayerName" },
          },
          [_vm._v("\n      " + _vm._s(_vm.modifiedName) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mmp-legend-actions" }, [
          _c(
            "button",
            {
              staticClass: "mmp-legend-btn",
              attrs: {
                id: "minOrMaxLayerLegendElement",
                title: _vm.legendMinimized
                  ? "Maximize Legend"
                  : "Minimize Legend",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    _vm.legendMinimized ? "maximizeLegend" : "minimizeLegend"
                  )
                },
              },
            },
            [
              _c("fa", {
                attrs: {
                  icon: [
                    "fas",
                    _vm.legendMinimized ? "window-maximize" : "window-minimize",
                  ],
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "mmp-legend-btn mmp-legend-btn--close",
              attrs: { id: "closeLayerLegendElement", title: "Close Legend" },
              on: {
                click: function ($event) {
                  return _vm.$emit("closeLegend")
                },
              },
            },
            [_c("fa", { attrs: { icon: ["fas", "window-close"] } })],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.legendMinimized,
            expression: "!legendMinimized",
          },
        ],
        staticClass: "mmp-legend-body",
      },
      [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.legendMinimized,
              expression: "!legendMinimized",
            },
          ],
          attrs: { id: "imgLegend", src: _vm.legendImgSrc },
          on: {
            load: function ($event) {
              return _vm.getDimensions()
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }